import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import CaseMinder from "@/pages/CaseMinder";
import ComplianceMinder from "@/pages/ComplianceMinder";
import ElectraHR from "@/pages/ElectraHR";
import Training from "@/pages/Training";
import BookWalkthrough from "@/pages/BookWalkthrough";
import Brand from "@/pages/Brand";
import Founder from "@/pages/Founder";
import Playbook from "@/pages/Playbook";
import Resources from "@/pages/Resources";
import OnePager from "@/pages/OnePager";
import TheWhy from "@/pages/TheWhy";
import FAQ from "@/pages/FAQ";
import Insights from "@/pages/Insights";
import InsightPost from "@/pages/InsightPost";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";
import NotFound from "@/pages/NotFound";

// The site's pages. Exported on its own so the build can render each public
// page to HTML in Node (scripts/ssr-render.js) under a server-side router.
export function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/caseminder" element={<CaseMinder />} />
        <Route path="/complianceminder" element={<ComplianceMinder />} />
        <Route path="/electra-hr" element={<ElectraHR />} />
        <Route path="/training" element={<Training />} />
        <Route path="/book-a-walkthrough" element={<BookWalkthrough />} />
        <Route path="/brand" element={<Brand />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/founder" element={<Founder />} />
        <Route path="/playbook" element={<Playbook />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<InsightPost />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/one-pager" element={<OnePager />} />
      <Route path="/the-why" element={<TheWhy />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid hsl(var(--border))",
            background: "hsl(var(--card))",
            color: "hsl(var(--card-foreground))",
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
